import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getAMLSTMCommonTransactionTriggeredTypologies } from '../../../redux/actions/tmCommon';
import TypologiesModal from './TypologiesModal';

const mapStateToProps = (state) => {
  const { transactionTriggeredTypologies = {} } = state.amlsTMCommon;
  const { error, isLoading, data: typologies } = transactionTriggeredTypologies;
  return {
    error,
    isLoading,
    typologies
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    apiActions: bindActionCreators(
      {
        getAMLSTMCommonTransactionTriggeredTypologies
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TypologiesModal);
